module.exports = __webpack_public_path__ + "img/close.302afeb6.svg";